module.exports = __webpack_public_path__ + "img/home-two3.f93b307c.png";